import { SET_BENUTZER, SET_BENUTZER_NAME, SAVE_SETTINGS, INITIALISE_STATE, SET_LANGUAGE, SET_PRIVILEGED_USER_MENU, SET_PRIVILEGED_USER } from '../actions/types';

const initialState = {
  checked: false,
  CurrentUserId: "",
  CurrentUserName: "",
  CurrentIDBerater: "",
  CurrentLang: "de",
  PrivilegedUserMenu: false,
  PrivilegedUser: false, //Korisnik koji može vidjeti sve vozače i odraditi sync podatka
}

export default function (state = initialState, action) {
  switch (action.type) {
    case INITIALISE_STATE:
      if (!action.settings) return state;
      return action.settings;
    case SET_BENUTZER_NAME:
      return { ...state, CurrentUserName: action.payload };
    case SET_BENUTZER:
      return { ...state, checked: action.payload.checked, CurrentUserId: action.payload.CurrentUserId, CurrentIDBerater: action.payload.CurrentIDBerater }
    case SAVE_SETTINGS:
      return state;
    case SET_LANGUAGE:
      return { ...state, CurrentLang: action.payload.id }
    case SET_PRIVILEGED_USER_MENU:
      return { ...state, PrivilegedUserMenu: action.payload }
    case SET_PRIVILEGED_USER:
      return { ...state, PrivilegedUser: action.payload }
    default:
      return state;
  }
}
